export const Card = ({ children, className = "" }) => (
  <div className={`rounded-xl shadow-lg bg-white border border-gray-300 ${className}`}>{children}</div>
)

export const CardHeader = ({ children, className = "" }) => <div className={`p-6 ${className}`}>{children}</div>

export const CardTitle = ({ children, className = "" }) => (
  <h2 className={`text-xl font-bold text-black ${className}`}>{children}</h2>
)

export const CardContent = ({ children, className = "" }) => <div className={className}>{children}</div>
